export const DONATION_CAPS_CENTS = {
  free: 25000,
  standard: 50000,
  plus: 50000,
  premium: 100000,
};

export function getDonationCapCents(plan = "free") {
  return DONATION_CAPS_CENTS[plan] || DONATION_CAPS_CENTS.free;
}

export function getDonationCapAmount(plan = "free") {
  return getDonationCapCents(plan) / 100;
}
